import type { CanvasContext } from '@studio/design-system/canvas';
import { omit } from 'lodash-es';
import type { ReactElement } from 'react';
import { useRef } from 'react';
import { twMerge } from 'cn';
import { Cursor } from '../cursor/index.js';
import type { HandlerProps } from '../types.js';
import { useWiring } from './wiring.js';

/** `Tool.FastFrame` `<Handler>` component. */
export const Handler = (props: HandlerProps): ReactElement => {
  const canvasRef = useRef<CanvasContext>(null);
  const wiring = useWiring(props.deviceId, canvasRef);

  const key = `center-${wiring.useCine ? 'cine' : 'standard'}`;

  return (
    <Cursor
      className={twMerge('stroke-success', props.className)}
      initialPosition={wiring.initialPosition}
      key={key}
      onClick={wiring.handleClickEvent}
      onDrawCursor={wiring.handleDrawCursor}
      onWheel={wiring.handleWheelEvent}
      ref={canvasRef}
      {...omit(props, 'deviceId', 'className')}
    />
  );
};
